export default "__VITE_ASSET__CDp2Eu2i__"